module.exports = __webpack_public_path__ + "static/img/Lachlan-Lam.20e7fce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Lachlan-Lam.jpg
// module id = HqnH
// module chunks = 0